import {Button, Box, RadioGroup, FormControlLabel, Radio} from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useGameContext } from './GameContext';
import {useEffect, useState} from 'react';

function Welcome() {
  let navigate = useNavigate();
  let { createRoom } = useGameContext();

  let [creatingRoom, setCreatingRoom] = useState(false);

  let [gameMode, setGameMode] = useState(localStorage.getItem('gameMode') || 'normal');

  useEffect(() => {
    localStorage.setItem('gameMode', gameMode);
  }, [gameMode]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1em',
        }}
      >
        <Button
          variant="contained"
          size="large"
          style={{
            cursor: 'pointer',
            fontSize: '4em',
            textTransform: 'none',
          }}
          onClick={() => {
            setCreatingRoom(true);
            createRoom((code) => {
              navigate(`/game/${code}`);
            });
          }}
          disabled={creatingRoom}
        >
          create room
        </Button>
        <Button variant="contained"
          size="large"
          style={{
            cursor: 'pointer',
            fontSize: '4em',
            textTransform: 'none',
          }}
          onClick={() => navigate(`/enter-code`)}
          disabled={creatingRoom}
        >
          join room
        </Button>
      </Box>

        <RadioGroup
            row
            aria-label="game-mode"
            name="game-mode"
            defaultValue="normal"
            style={{marginTop: '2em'}}
            onChange={(e) => {
                setGameMode(e.target.value);
            }}
            value={gameMode}
        >
            <FormControlLabel value="normal" control={<Radio/>} label="Normal"/>
            <FormControlLabel value="equal-points" control={<Radio/>} label="Equal Points"/>
        </RadioGroup>
    </Box>
  );
}

export default Welcome;
